import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getCostComponentListAsync } from 'src/services/costModelling/shouldCostLibrary.services'

const initialState = {
  costComponentList: [],
  costComponentListLoader: false,
  draggedComponent: null,
}

export const getCostComponentListSlice = createSlice({
  name: 'cost-components-slice',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getCostComponentListAsync.pending), (state) => {
      state.costComponentListLoader = true
    })
    builder.addMatcher(isAnyOf(getCostComponentListAsync.fulfilled), (state, action) => {
      state.costComponentListLoader = false
      // Sort the data according to the specified order
      const orderedCostComponentData =
        Array.isArray(action?.payload?.data) && action?.payload?.data.length > 0
          ? action?.payload?.data
              .map((obj) => ({
                id: obj?.id,
                componentName: obj?.component_name,
                disabled: false,
                value: 0.00,
                order_id: obj?.component_order_id,
              }))
          : []
        
        state.costComponentList = orderedCostComponentData
    })
    builder.addMatcher(isAnyOf(getCostComponentListAsync.rejected), (state, action) => {
      state.costComponentListLoader = false
    })
  },
  reducers: {
    //set the component index being dragged
    setDraggedComponent: (state, action) => {
      state.draggedComponent = action.payload
    },

    //action passed is index of component and when used this reducer means that this compoenent gets disabled
    addDraggedComponent: (state, action) => {
      state.costComponentList = state?.costComponentList?.map((obj) => {
        return obj.id === action?.payload
          ? {
              ...obj,
              disabled: true,
            }
          : obj
      })
    },
    //action passed is index of component and when used this reducer  means that this compoenent gets enabled
    removeDraggedComponent: (state, action) => {
      state.costComponentList = state?.costComponentList?.map((obj) => {
        return obj.id === action?.payload
          ? {
              ...obj,
              disabled: false,
            }
          : obj
      })
    },

    makeComponentsEnableDisable: (state, action) => {
      state.costComponentList = state?.costComponentList?.map((obj) => {
        const shouldDisable = action?.payload?.includes(obj?.componentName)
        return {
          ...obj,
          disabled: shouldDisable,
        }
      })
    },
    resetCostComponentList: () => initialState,
    updateComponentList: (state, action) => {
      state.costComponentList = action?.payload
    },
  },
})

export const {
  setDraggedComponent,
  resetCostComponentList,
  addDraggedComponent,
  removeDraggedComponent,
  makeComponentsEnableDisable,
  updateComponentList,
} = getCostComponentListSlice.actions

export default getCostComponentListSlice.reducer
